// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2F6dx","label":"Radio_label__2wUw-","checkMark":"Radio_checkMark__3uUZF","disabled":"Radio_disabled__3gD1r"};